import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Title } from '@dropbox/dig-components/typography';
import styles from './white-labeling-app.module.scss';
import AccordionColorPicker from './accordion-color-picker';
import { FormattedMessage } from 'react-intl';
import { Button } from '@dropbox/dig-components/buttons';
import { MessageType, postTo } from 'js/sign-components/common/ts-message';
import {
  whiteLabelingNew,
  WhiteLabelingPropertyIdNew,
} from 'js/sign-components/common/white-labeling-new';
import { useSectionsNew } from './use-sections-new';

export const WhiteLabelingAppNew = () => {
  const [colors, setColors] = useState(whiteLabelingNew);
  const [iframeKey, setIframeKey] = useState(0);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [logoUrl, setLogoUrl] = useState<string>();

  const updateColors = useCallback(() => {
    if (iframeRef.current?.contentWindow) {
      postTo(iframeRef.current.contentWindow, {
        type: MessageType.SignerAppDemoWhiteLabelingNew,
        whiteLabeling: colors,
      });
    }
  }, [colors]);

  const updateLogo = useCallback(() => {
    if (iframeRef.current?.contentWindow) {
      postTo(iframeRef.current.contentWindow, {
        type: MessageType.SignerAppDemoLogoUrl,
        url: logoUrl ?? '',
      });
    }
  }, [logoUrl]);

  useEffect(() => {
    updateColors();
  }, [updateColors]);

  useEffect(() => {
    updateLogo();
  }, [updateLogo]);

  const updateIframe = () => {
    updateColors();
    updateLogo();
  };

  const refreshIframe = () => {
    setIframeKey(iframeKey + 1);
  };

  const sections = useSectionsNew();

  return (
    <div className={styles.wrapper}>
      <div className={styles.accordionWrapper}>
        <AccordionColorPicker<WhiteLabelingPropertyIdNew>
          getValue={(id) => colors[id]}
          setValue={(id, value) =>
            setColors((prev) => ({ ...prev, [id]: value }))
          }
          sections={sections}
          setLogoUrl={setLogoUrl}
        />
      </div>
      <div
        className={styles.preview}
        data-qa-ref="white-labeling-preview-selection"
      >
        <div className={styles.previewHeader}>
          <Title size="small">
            <FormattedMessage
              id=""
              description="Preview Title"
              defaultMessage="Preview"
            />
          </Title>
          <div className={styles.viewSelectorRow}>
            <Button variant="primary" onClick={refreshIframe}>
              <FormattedMessage
                id=""
                description="Button which restarts the contract from first page"
                defaultMessage="Restart Contract"
              />
            </Button>
          </div>
        </div>

        <div className={styles.previewComponentWrapper}>
          <iframe
            key={iframeKey}
            ref={iframeRef}
            src={'/api/white-labeling-signer-demo'}
            className={styles.signerIframe}
            onLoad={updateIframe}
          />
        </div>
      </div>
    </div>
  );
};
